var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "custom-wrapper"
  }, [_c("a-form-model", {
    ref: "customFrom",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "customColor",
      label: "主题配置"
    }
  }, [_c("a-radio-group", {
    attrs: {
      "button-style": "solid",
      value: _vm.theme
    },
    on: {
      change: _vm.changeTheme
    }
  }, _vm._l(_vm.customList, function (item) {
    return _c("a-radio-button", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "layout",
      label: "布局方式"
    }
  }, [_c("a-radio-group", {
    attrs: {
      value: _vm.layout,
      "button-style": "solid"
    },
    on: {
      change: _vm.changeLayout
    }
  }, _vm._l(_vm.layoutList, function (item) {
    return _c("a-radio-button", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "tagShow",
      label: "开启标签"
    }
  }, [_c("a-switch", {
    attrs: {
      checked: _vm.tagShow,
      "checked-children": "开",
      "un-checked-children": "关"
    },
    on: {
      change: _vm.changeTag
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "fixedHeader",
      label: "固定头部"
    }
  }, [_c("a-switch", {
    attrs: {
      checked: _vm.fixHeader,
      "checked-children": "开",
      "un-checked-children": "关"
    },
    on: {
      change: _vm.changeHeader
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };